<template>
    <div>
        <!--
        <app-header></app-header>
        <main id="page-main">
            <div>

                -->

                <router-view @refresh="refresh()"></router-view>
                <header class="content-header">
                    <div class="wrapper">

                        <div>
                            <h1>Template</h1>
                            <p>Gestion des templates</p>
                        </div>

                        <div class="actions">
                            <ul>
                                <li><button-action type="export"/></li>
                                <li><button-action  type="create"/></li>
                            </ul>
                        </div>

                    </div>
                </header>
                <div class="content-body">

                    <section>
                        <div class="search">
                            <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                            <!--
                            <div>
                                <ul>
                                    <li><button><span>Menu 1</span></button></li>
                                    <li><button><span>Menu 1</span></button></li>
                                    <li><button><span>Menu 1</span></button></li>
                                </ul>
                            </div>
                            -->
                        </div>

                        <h2 class="datagrid-results" v-if="resources && resources.length"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

                        <div class="campaigns" v-if="resources && resources.length">
                            <div class="datagrid" :class="paginator.listing">
                                <div class="datagrid-header">
                                    <div>
                                        <div></div>
                                        <div></div>
                                        <div>
                                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                                        </div>
                                        <div class="center">Publié</div>
                                        <div>Scopes</div>
                                        <div class="actions"></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div class="datagrid-body">
                                    <div v-for="item in resources" @dblclick="edit(item.id)">
                                        <div></div>
                                        <div class="picture">
                                            <figure>
                                                <i v-if="!item.picture" class="icon icon-icon_files"></i>
                                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                            </figure>
                                        </div>
                                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                                        <div class="center"><published v-model="item.published"></published></div>
                                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                                        <div class="actions">
                                            <ul>
                                                <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                                <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                            </ul>
                                        </div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="empty-actions" v-if="resources && resources.length == 0">
                            <div @click="create()">
                                <i class="icon icon-icon_files"></i>
                                <h3>Créer un template</h3>
                                <p>Créer un template de newsletter prêt à l'emploi.</p>
                                <button><span>Créer</span></button>
                            </div>
                        </div>

                    </section>

                    <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

                </div>

        <!--
            </div>
        </main>
        -->

    </div>
</template>
<script>
    import TemplateService from './TemplateService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return TemplateService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/campaign/template/Index.vue